import { type GasPayload } from '@atlaskit/analytics-gas-types';

import { ACTION_SUBJECT_PREFIX } from '../../../constants/analytics';

/** button clicked searchPageQuickFindFiltersToggleButton */
export const onQuickFindFiltersToggleButtonClicked = ({
	attributes,
	isExpanded,
	nonPrivacySafeAttributes,
}: {
	attributes: Record<string, any>;
	isExpanded: boolean;
	nonPrivacySafeAttributes: Record<string, any>;
}): GasPayload => ({
	eventType: 'ui',
	action: 'clicked',
	actionSubject: 'button',
	actionSubjectId: `${ACTION_SUBJECT_PREFIX}QuickFindFiltersToggleButton`,
	attributes: {
		...attributes,
		isExpanded,
	},
	nonPrivacySafeAttributes,
});
